import {
    createRouter,
    createWebHashHistory,
} from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import Router from 'vue-router'

const routes = [
    // {
    //     path: '/',
    //     name: 'home',
    //     component: HomeView,
    //     meta: {
    //         keepAlive: true
    //     }
    // },
    {
        path: '/',
        name: 'test',
        component: () => import('../views/test'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/myTeam',
        name: 'myTeam',
        component: () => import('../views/myTeam/index'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/myTeamInfo',
        name: 'myTeamInfo',
        component: () => import('../views/myTeamInfo/index'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/memberList',
        name: 'memberList',
        component: () => import('../views/MemberList/index'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/teamInfo',
        name: 'teamInfo',
        component: () => import('../views/teamInfo/index'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/signUpGame',
        name: 'signUpGame',
        component: () => import('../views/signUpGame/index'),
        meta: {
            keepAlive: true
        },
    },
    {
        path: '/signUpSuccessful/:id',
        name: 'signUpSuccessful',
        component: () => import('../views/signUpSuccessful/index'),
        meta: {
            keepAlive: true
        },
    },
]


const router = createRouter({
    history: createWebHashHistory(),
    routes
})
router
export default router
